import { useTranslation } from "react-i18next";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { SEO } from "@/components/SEO";
import { SEOBreadcrumb } from "@/components/SEOBreadcrumb";
import { BrutalCard } from "@/components/ui/BrutalCard";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Link } from "react-router-dom";

const FAQ_CATEGORIES = [
  { key: "general", questionCount: 4 },
  { key: "users", questionCount: 4 },
  { key: "professionals", questionCount: 6, hasHtmlContent: true },
  { key: "subscriptions", questionCount: 5 },
  { key: "events", questionCount: 4 },
  { key: "jobs", questionCount: 4 },
  { key: "visibility", questionCount: 3 },
  { key: "affiliate", questionCount: 3 },
  { key: "creator", questionCount: 3 },
  { key: "privacy", questionCount: 4 },
];

const FAQ = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title={t("faqPage.seoTitle")}
        description={t("faqPage.seoDescription")}
      />
      <Header />

      <main className="flex-1">
        {/* Hero Section */}
        <section className="bg-surface py-20 px-4">
          <div className="max-w-4xl mx-auto text-center">
            <SEOBreadcrumb items={[{ label: t("faqPage.heroTitle") }]} />
            <h1 className="font-heading text-4xl md:text-6xl font-bold mb-6 text-dark">
              {t("faqPage.heroTitle")}
            </h1>
            <p className="text-xl text-gray-700">
              {t("faqPage.heroSubtitle")}
            </p>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-16 px-4">
          <div className="max-w-4xl mx-auto space-y-8">
            {FAQ_CATEGORIES.map((category) => (
              <div key={category.key}>
                <h2 className="font-heading text-2xl font-bold mb-6 text-primary">
                  {t(`faqPage.categories.${category.key}.title`)}
                </h2>
                <BrutalCard>
                  <Accordion type="single" collapsible className="w-full">
                    {Array.from({ length: category.questionCount }).map((_, index) => (
                      <AccordionItem key={index} value={`${category.key}-item-${index}`}>
                        <AccordionTrigger className="font-heading font-bold text-left">
                          {t(`faqPage.categories.${category.key}.q${index + 1}`)}
                        </AccordionTrigger>
                        <AccordionContent className="text-gray-700">
                          {category.hasHtmlContent ? (
                            <span dangerouslySetInnerHTML={{ __html: t(`faqPage.categories.${category.key}.a${index + 1}`) }} />
                          ) : (
                            t(`faqPage.categories.${category.key}.a${index + 1}`)
                          )}
                        </AccordionContent>
                      </AccordionItem>
                    ))}
                  </Accordion>
                </BrutalCard>
              </div>
            ))}
          </div>
        </section>

        {/* Contact CTA */}
        <section className="py-16 px-4 bg-primary">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="font-heading text-3xl font-bold mb-4 text-dark">
              {t("faqPage.ctaTitle")}
            </h2>
            <p className="text-xl mb-8 text-dark/90">
              {t("faqPage.ctaSubtitle")}
            </p>
            <Link
              to="/contact"
              className="inline-block px-8 py-4 bg-dark text-white font-heading font-bold uppercase tracking-wider border-[3px] border-dark shadow-[6px_6px_0px_#000] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[4px_4px_0px_#000] transition-all"
            >
              {t("faqPage.ctaButton")}
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default FAQ;
